import { queryClient } from '@/providers/QueryClientProvider';
import { USE_DASHBOARD_SETTINGS_QUERY_KEY } from './types';

export const invalidateUseDashboardSettings = () =>
  queryClient.invalidateQueries([USE_DASHBOARD_SETTINGS_QUERY_KEY]);
